var _g, _ellipse, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationComplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 121,
    viewBox: "0 0 135 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41839_380723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.28644 25.8187V15.533C5.28644 9.72301 9.98328 5.24725 16.0802 5.24725H26.874C28.2497 5.24725 29.3649 4.18454 29.3649 2.87363C29.3649 1.56271 28.2497 0.5 26.874 0.5H16.0802C7.23193 0.5 0.304688 7.10117 0.304688 15.533V25.8187C0.304688 27.1296 1.41989 28.1923 2.79556 28.1923C4.17124 28.1923 5.28644 27.1296 5.28644 25.8187Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1979 25.8187V15.533C92.1979 9.72301 87.5011 5.24725 81.4041 5.24725H70.6103C69.2347 5.24725 68.1195 4.18454 68.1195 2.87363C68.1195 1.56271 69.2347 0.5 70.6103 0.5H81.4041C90.2524 0.5 97.1797 7.10117 97.1797 15.533V25.8187C97.1797 27.1296 96.0645 28.1923 94.6888 28.1923C93.3131 28.1923 92.1979 27.1296 92.1979 25.8187Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28644 67.4884V77.7742C5.28644 83.5841 9.98328 88.0599 16.0802 88.0599H26.874C28.2497 88.0599 29.3649 89.1226 29.3649 90.4335C29.3649 91.7444 28.2497 92.8071 26.874 92.8071H16.0802C7.23193 92.8071 0.304688 86.206 0.304688 77.7742V67.4884C0.304688 66.1775 1.41989 65.1148 2.79556 65.1148C4.17124 65.1148 5.28644 66.1775 5.28644 67.4884Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1979 67.4884V77.7742C92.1979 83.5841 87.5011 88.0599 81.4041 88.0599H70.6103C69.2347 88.0599 68.1195 89.1226 68.1195 90.4335C68.1195 91.7444 69.2347 92.8071 70.6103 92.8071H81.4041C90.2524 92.8071 97.1797 86.206 97.1797 77.7742V67.4884C97.1797 66.1775 96.0645 65.1148 94.6888 65.1148C93.3131 65.1148 92.1979 66.1775 92.1979 67.4884Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6523 35.3614V41.9586C26.6523 43.3241 27.7366 44.4311 29.074 44.4311C30.4115 44.4311 31.4957 43.3241 31.4957 41.9586V35.3614C31.4957 33.9959 30.4115 32.8889 29.074 32.8889C27.7366 32.8889 26.6523 33.9959 26.6523 35.3614Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5742 35.3614V41.9586C66.5742 43.3241 67.6584 44.4311 68.9959 44.4311C70.3334 44.4311 71.4176 43.3241 71.4176 41.9586V35.3614C71.4176 33.9959 70.3334 32.8889 68.9959 32.8889C67.6584 32.8889 66.5742 33.9959 66.5742 35.3614Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7005 68.6723C36.4241 72.8735 42.1451 74.9936 48.7346 74.9936C55.3242 74.9936 61.0451 72.8735 65.7688 68.6723C66.798 67.7569 66.8536 66.2198 65.893 65.239C64.9324 64.2582 63.3194 64.2052 62.2902 65.1206C58.5167 68.4767 54.0411 70.1353 48.7346 70.1353C43.4282 70.1353 38.9526 68.4767 35.1791 65.1206C34.1499 64.2052 32.5368 64.2582 31.5762 65.239C30.6156 66.2198 30.6712 67.7569 31.7005 68.6723Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7332 35.3181V52.3221C48.7332 53.4103 48.175 53.9415 47.0274 53.9415H45.3343C43.9264 53.9415 42.7852 55.0291 42.7852 56.3707C42.7852 57.7123 43.9264 58.7998 45.3343 58.7998H47.0274C50.9894 58.7998 53.8314 56.0947 53.8314 52.3221V35.3181C53.8314 33.9765 52.6901 32.8889 51.2823 32.8889C49.8744 32.8889 48.7332 33.9765 48.7332 35.3181Z",
    fill: "#1F1F1F"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.7633,
    cy: 84.7306,
    rx: 30.0289,
    ry: 28.6154,
    fill: "#D9F2E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.5039 83.4722L93.8453 91.421L107.748 78.1731",
    stroke: "#157947",
    strokeWidth: 1.55,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41839_380723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.8674,
    height: 92.3077,
    fill: "white",
    transform: "translate(0.304688 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationComplete);
export default __webpack_public_path__ + "static/media/verification_complete.8a7d27de501b630ad9b0f92e34323dde.svg";
export { ForwardRef as ReactComponent };